import './ui.css';

const VARIANT_ROLE = {
  info: 'status',
  success: 'status',
  warning: 'status',
  error: 'alert',
};

/**
 * 共用提示區塊。只負責呈現，不做 API message mapping。
 */
export default function Alert({
  variant = 'info',
  title,
  children,
  actions = null,
  className = '',
  ...rest
}) {
  const role = VARIANT_ROLE[variant] || 'status';
  const live = variant === 'error' ? 'assertive' : 'polite';

  return (
    <div
      className={`ui-alert ui-alert--${variant} ${className}`.trim()}
      role={role}
      aria-live={live}
      {...rest}
    >
      {title ? <h2 className="ui-alert__title">{title}</h2> : null}
      {children ? <div className="ui-alert__body">{children}</div> : null}
      {actions ? <div className="ui-alert__actions">{actions}</div> : null}
    </div>
  );
}
